<script setup lang="ts">
import { navigateTo } from '#app'
import SimpleHeader from '~/components/molecules/SimpleHeader.vue'
import MyselfSidebar from '~/components/organisms/MyselfSidebar.vue'
import TheSnackbar from '~/components/organisms/TheSnackbar.vue'
</script>

<template>
  <div>
    <SimpleHeader @back="() => navigateTo('/')" />
    <TheSnackbar />
    <div class="columns">
      <nav class="sidebar is-narrow hero is-fullheight">
        <MyselfSidebar />
      </nav>
      <main class="column">
        <slot />
      </main>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.columns {
  margin: 0;
}

.sidebar {
  border-right: 1px solid var(--semantic-tokens-neutral-weak-border);
}
</style>
